<template>
    <v-flex class="ypo-error-page" v-if="ypoErrorData" v-html="ypoErrorData"></v-flex>
</template>

<script>
    import { myToolsConstants } from "../Tools/mytools.constant";
    import { mapGetters } from "vuex";
    import { storeGetters } from "@/store/storeGetters.constant";

    export default {
        name: "YpoError",
        data: () => ({
           myToolsConstants,
        }),
        computed: {
            ...mapGetters({
               ypoErrorData: `ypoError/${storeGetters.ypoErrorData}`,
            }),
        },
    };
</script>
<style lang="scss" scoped>
  .ypo-error-page {
    padding: 30px 45px;
  }
</style>
